export const URL_SOCCER_PAGE = {
    LIVESCORE: '/bong-da/livescore.epi',
    LIVE: '/bong-da/truc-tiep.epi',
    HOME: '/bong-da.epi',
    ALL_LEAGUES: '/bong-da/tat-ca-giai-dau.epi',
    SUBPATH: '/bong-da/'
};

export const TAB_IDS = {
    NEWS: 'tin-tuc',
    OVERVIEW: '',
    STANDING: 'bang-xep-hang',
    STATISTIC: 'thong-ke',
    MATCHES: 'lich-thi-dau',
    KNOCKOUT: 'loai-truc-tiep',
    TEAMS: 'doi-bong',
    TRANSFER: 'chuyen-nhuong',
    SQUAD: 'doi-hinh',
};

export const convertTabId = (id: string) => {
    switch (id) {
        case 'standing':
            return TAB_IDS.STANDING;
        case 'news':
            return TAB_IDS.NEWS;
        case 'statistic':
            return TAB_IDS.STATISTIC;
        case 'teams':
            return TAB_IDS.TEAMS;
        case 'matches':
            return TAB_IDS.MATCHES;
        case 'knockout':
            return TAB_IDS.KNOCKOUT;
        case 'transfer':
            return TAB_IDS.TRANSFER;
        case 'squad':
            return TAB_IDS.SQUAD;
        default:
            return TAB_IDS.OVERVIEW;
    }
};
